const Post15Summary = (lang) => {
	const isRom = lang === 'rom'

	
	return {
		lang,
		cardTitle: isRom?  'Ce a lăsat în urmă' :'Things she left behind',	
		cardText:  isRom ?  'În această postare, mă uit la câteva lucruri care au aparținut bunicii mele, Aurelia, o colecție puțin ciudată, niște piese de costum popular, câteva tablouri, o hartă și un document administrativ si ce ne spun aceste obiecte despre ea și vremurile in care a trait.': 
		'In this post, I am looking at a few things that used to belong to my grandmother Aurelia, a bit of an odd collection that, what what some folk costume pieces, a couple of paintings, a map and an admin document can tell us about her and her times.', 
		photoPath: '/post15/collage15l.jpg', 
		photoPathShort: '/post15/collage15s.jpg', 
		linkId: 'things'
	}

}

export default Post15Summary;
